import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import CustomerCard from "@core/ui/customer-card/customer-card";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Menubar } from "primereact/menubar";
import { Tag } from "primereact/tag";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import { IoAccessibility } from "react-icons/io5";
import { TbBinaryTree2 } from "react-icons/tb";
import { Outlet, useNavigate } from "react-router-dom";

import { useEditCustomer } from "./edit-customer.hook";

export function EditCustomer() {
  const {
    personData,
    isLoading,
    personError,
    formMethod,
    balanceData,
    avatar,
    displayMode,
    userLevelData,
    upgradeElement,
    setDisplayMode,
    handleBack,
    handleAction,
    cardElement,
    getActions,
  } = useEditCustomer();
  const navigate = useNavigate();
  const { getUserRole, getClientFeatures } = useUserIdentityContext();
  const clientFeatures = getClientFeatures();
  const userRole = getUserRole();
  const items = [
    {
      label: "Information",
      icon: <IoAccessibility className="block mr-2" />,
      command: () => navigate(``),
    },
    {
      label: "Transactions",
      icon: <GrTransaction className="block mr-2" />,
      command: () => navigate(`transaction`),
    },
    ...(clientFeatures?.featureReferral
      ? [
        {
          label: "Referrals",
          icon: <TbBinaryTree2 className="block mr-2" />,
          command: () => navigate(`referrals`),
        },
      ]
      : []),
  ];

  const title =
    personData?.first_name && personData?.last_name ? (
      <div className="flex flex-col">
        <h1 className="capitalize">
          {personData?.first_name} {personData?.last_name}
        </h1>
        <div className="flex gap-2">
          {personData.is_locked ? (
            <Tag value="Locked" className="bg-amber-600 w-16" />
          ) : null}
          {personData.is_blocked ? (
            <Tag value="Blocked" className="bg-red-600 w-16" />
          ) : null}
        </div>
      </div>
    ) : (
      <h1>Edit Customer</h1>
    );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 gap-2 mb-4">
        <div className="flex justify-center">
          <CustomerCard
            userLevel={userLevelData}
            balanceData={balanceData}
            avatar={avatar}
            shouldShowCard={true}
            onChangeDisplay={(mode) => setDisplayMode(mode)}
          />

          {cardElement(balanceData, displayMode)}
        </div>

        <Menubar className="bg-white p-4 mt-4" model={items} />
      </section>
    </div>
  );

  return (
    <div id="EditCustomer" className="person">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        {userRole?.name.toUpperCase() === LocalRole.Cashier ? null : (
          <HeaderButton actions={getActions()} onAction={handleAction} />
        )}
      </HeaderContent>
      {upgradeElement}

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {personError && !isLoading && displayError}
          {!isLoading ? mainContent : null}

          <div className="bg-white p-6">
            <Outlet />
          </div>
        </FormProvider>
      </section>
    </div>
  );
}

export default EditCustomer;
